import React from 'react';

import { Typography } from '@sravni/react-design-system';
import pluralize from '@sravni/utils/lib/pluralize';

import styles from '../comments-list.module.scss';

import { Form } from './Form';

interface IProps {
  totalComments: number;
  isLoggedIn: boolean;
  currentUserId: string;
  handleCreateComment: (text: string) => Promise<void>;
  isRepresentative?: boolean;
  isModerator?: boolean;
  showAuthPopup: () => void;
}

export const ListHeading: React.FC<IProps> = ({
  totalComments,
  isLoggedIn,
  currentUserId,
  handleCreateComment,
  isRepresentative,
  isModerator,
  showAuthPopup,
}) => {
  const handleSubmit = async (text: string) => {
    await handleCreateComment(text);
  };

  return (
    <>
      <Typography.Heading as={'h2'} level={4}>
        {totalComments
          ? `${totalComments} ${pluralize(totalComments, 'комментарий', 'комментария', 'комментариев')}`
          : 'Ещё никто не оставил комментарий, вы можете быть первым'}
      </Typography.Heading>
      {isLoggedIn ? (
        <Form
          label={'Написать комментарий'}
          onSubmit={handleSubmit}
          currentUserId={currentUserId}
          showWysiwyg={isRepresentative || isModerator}
        />
      ) : (
        <Typography.Text size={16} className={'h-mt-32'}>
          <Typography.Text size={16} as={'button'} className={styles.loginButton} onClick={showAuthPopup}>
            Войдите
          </Typography.Text>{' '}
          чтобы оставить комментарий.
        </Typography.Text>
      )}
    </>
  );
};
